import { render } from "./SolutionData.vue?vue&type=template&id=4ac39047&scoped=true"
import script from "./SolutionData.vue?vue&type=script&lang=js"
export * from "./SolutionData.vue?vue&type=script&lang=js"

import "./SolutionData.vue?vue&type=style&index=0&id=4ac39047&scoped=true&lang=css"

import exportComponent from "D:\\dev_workspace\\cy\\web\\linkomweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac39047"]])

export default __exports__